import { useTranslation } from 'react-i18next'

import { Text } from '@reveni-io/reveni-ui'

const InfoPickingListText = ({ selectedParcels }) => {
  const { t } = useTranslation()

  return (
    <>
      <Text type="bodyMRegular">
        {selectedParcels?.length === 1
          ? t('Estás a punto de generar la lista de recogida de productos para 1 envío en estado “solicitado”')
          : t(
              'Estás a punto de generar la lista de recogida de productos para {{count}} envíos en estado “solicitado”',
              {
                count: selectedParcels?.length,
              }
            )}
      </Text>
      <Text type="bodyMRegular">
        {t('Este proceso puede tardar unos momentos. Por favor, ten paciencia mientras se completa.')}
      </Text>
    </>
  )
}

export default InfoPickingListText
